const SafeText = ({ text }) => {
  text = text.replace(/\\n/g, "\n");
    const lines = text.split("\n").map((line, index, array) => (
        index === array.length - 1 ? line: [line, <br key={index} />]
    ));

  return <span>{lines}</span>;
}

export default SafeText;